<template>
  <v-form ref="customerForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="12" xs="12" md="3">
        <v-text-field type="text" autocomplete="off" outlined dense label="Customer Name" v-model="record.Name"
          :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field type="text" autocomplete="off" outlined dense label="Phone" v-model="record.PhoneNumber"
          :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field type="text" autocomplete="off" outlined dense label="Email" v-model="record.Email"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field type="number" autocomplete="off" outlined dense label="Credit Limit"
          v-model="record.CreditLimit"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-text-field type="text" autocomplete="off" outlined dense label="Pin No"
          v-model="record.PinNo"></v-text-field>
      </v-col>

      <!-- <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" hide-details dense outlined v-model="record.storeId" :items="stores"
          label="Store / Shop" item-text="Name" item-value="id"></v-autocomplete>
      </v-col> -->

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="customerPriceList" hide-details dense outlined
          v-model="record.priceListId" :items="priceLists" label="Price List" item-text="Name"
          item-value="id"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="customerPaymentTerms" hide-details dense outlined
          v-model="record.paymentTermsId" :items="paymentTerms" label="Payment Terms" item-text="name"
          item-value="id"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="owner" hide-details dense outlined v-model="record.Owner"
          :items="users" label="Owner" item-text="name" item-value="id"></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="12">
        <v-textarea type="text" autocomplete="off" outlined dense label="Address" v-model="record.Address"
          rows="2"></v-textarea>
      </v-col>

      <v-col cols="12" xs="12" md="12" class="subtitle-2 text--primary">
        <v-radio-group dense
          label="Is consignment customer (Invoices are raised after delivered goods are sold at the customer braches)"
          v-model="IsConsignmentCustomer" row>
          <v-radio label="No" color="accent" value="N"></v-radio>
          <v-radio label="Yes" color="accent" value="Y"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" xs="12" md="12" class="subtitle-2 text--primary">
        <v-radio-group dense label="Print barcodes on this customer draft / delivery" v-model="PrintBarcodes" row>
          <v-radio label="No" color="accent" value="N"></v-radio>
          <v-radio label="Yes" color="accent" value="Y"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>

      <v-col cols="12">
        <div class="d-flex align-center mb-2">
          <span class="subtitle-1 font-weight-bold">Address Lines</span>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="openAddAddressModal">
            <v-icon small left>mdi-plus</v-icon>Add Address Line
          </v-btn>
        </div>

        <v-data-table :headers="addressHeaders" :items="addressLines" :items-per-page="5" dense
          :hide-default-footer="addressLines.length <= 5">
          <template v-slot:item.lineNumber="{ item }">
            {{ addressLines.indexOf(item) + 1 }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" text icon small @click="openEditAddressModal(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn color="red" text icon small @click="openDeleteAddressModal(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <!-- Add Address Line Modal -->
    <v-dialog v-model="addAddressDialog" max-width="500px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Add Address Line</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addAddressDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-form ref="addAddressForm" v-model="validAddAddress">
              <v-row class="text--primary subtitle-2">
                <v-col cols="12">
                  <v-text-field v-model="newAddressLine.addressLine" label="Address Line"
                    :rules="[v => !!v || 'Address line is required']" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" :loading="addressLoader" :disabled="!validAddAddress" @click="addAddressLine">
                    <v-icon left small>mdi-plus</v-icon>Add
                  </v-btn>
                  <v-btn text @click="addAddressDialog = false">Cancel</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Edit Address Line Modal -->
    <v-dialog v-model="editAddressDialog" max-width="500px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Edit Address Line</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="editAddressDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-form ref="editAddressForm" v-model="validEditAddress">
              <v-row class="text--primary subtitle-2">
                <v-col cols="12">
                  <v-text-field v-model="editedAddressLine.addressLine" label="Address Line"
                    :rules="[v => !!v || 'Address line is required']" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" :loading="addressLoader" :disabled="!validEditAddress"
                    @click="updateAddressLine">
                    Save Changes
                  </v-btn>
                  <v-btn text @click="editAddressDialog = false">Cancel</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Delete Address Line Modal -->
    <v-dialog v-model="deleteAddressDialog" max-width="500px">
      <v-card>
        <v-toolbar dense color="red" dark>
          <v-toolbar-title>Delete Address Line</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="deleteAddressDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="text--primary subtitle-2">
              <v-col cols="12">
                Are you sure you want to delete this address line?
              </v-col>
              <v-col cols="12">
                <span style="font-size: 16px; font-weight: bold">{{ selectedAddressLine.addressLine }}</span>
              </v-col>
              <v-col cols="12">
                <v-btn color="red" dark :loading="addressLoader" @click="deleteAddressLine">
                  Yes, Delete
                </v-btn>
                <v-btn text @click="deleteAddressDialog = false">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    valid: false,
    lazy: false,
    inputRules: [v => !!v || "Required"],
    IsConsignmentCustomer: "N",
    PrintBarcodes: "N",
    users: [],
    stores: [],
    priceLists: [],
    paymentTerms: [],
    CreditLimit: null,
    loader: false,
    date: new Date().toISOString().substr(0, 10),
    // Address Lines
    addressLines: [],
    addressHeaders: [
      { text: "#", value: "lineNumber", width: "60px" },
      { text: "Address Line", value: "addressLine" },
      { text: "Action", value: "action", width: "120px", sortable: false }
    ],
    addAddressDialog: false,
    editAddressDialog: false,
    deleteAddressDialog: false,
    validAddAddress: false,
    validEditAddress: false,
    addressLoader: false,
    newAddressLine: {
      addressLine: ""
    },
    editedAddressLine: {},
    selectedAddressLine: {}
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
      if (this.record.isConsignmentCustomer == 1) {
        this.IsConsignmentCustomer = "Y";
      } else {
        this.IsConsignmentCustomer = "N";
      }

      if (this.record.printBarcodes == 1) {
        this.PrintBarcodes = "Y";
      } else {
        this.PrintBarcodes = "N";
      }

      // Load address lines if customer has an ID
      if (this.record.id) {
        this.getAddressLines();
      } else {
        this.addressLines = [];
      }
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.customerForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      this.$store.commit("btnLoader", true);
      var storeId = parseInt(this.activeStore);
      this.record.store_id = storeId;
      this.record.Owner = parseInt(this.record.Owner);
      this.record.CreditLimit = parseInt(this.record.CreditLimit);
      this.record.IsConsignmentCustomer = this.IsConsignmentCustomer == "Y" ? 1 : 0;
      this.record.printBarcodes = this.PrintBarcodes == "Y" ? 1 : 0;
      this.$emit("data", this.record);
    },
    getPriceLists() {
      const self = this;
      this.$store
        .dispatch("get", `/price-list`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.priceLists = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOwners() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          self.users = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getPaymentTerms() {
      const self = this;
      this.$store
        .dispatch("get", `/payment-terms`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.paymentTerms = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    // Address Lines Methods
    getAddressLines() {
      if (!this.record.id) return;
      const self = this;
      this.$store
        .dispatch("get", `/customer-address-lines/${this.record.id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.addressLines = res.ResponseData || [];
          } else {
            self.addressLines = [];
          }
        })
        .catch(err => {
          self.$refs.snackbar.show(err, "red");
        });
    },
    openAddAddressModal() {
      this.newAddressLine = { addressLine: "" };
      this.addAddressDialog = true;
    },
    addAddressLine() {
      if (!this.$refs.addAddressForm.validate()) {
        return;
      }

      if (!this.record.id) {
        // If customer doesn't have an ID yet, just add to local array
        this.addressLines.push({ ...this.newAddressLine });
        this.addAddressDialog = false;
        this.$refs.snackbar.show("Address line added", "green");
        return;
      }

      const url = `/customer-address-lines`;
      const payload = {
        customerId: this.record.id,
        addressLine: this.newAddressLine.addressLine
      };
      const self = this;
      this.addressLoader = true;
      this.$store
        .dispatch("post", { url, data: payload })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.addressLoader = false;
            self.addAddressDialog = false;
            self.getAddressLines();
            self.$refs.snackbar.show("Address line added successfully", "green");
          } else {
            self.addressLoader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.addressLoader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    openEditAddressModal(item) {
      this.editedAddressLine = { ...item };
      this.editAddressDialog = true;
    },
    updateAddressLine() {
      if (!this.$refs.editAddressForm.validate()) {
        return;
      }

      if (!this.editedAddressLine.id) {
        // If it's a local item without ID, update in local array
        const index = this.addressLines.findIndex(line => line === this.editedAddressLine);
        if (index !== -1) {
          this.$set(this.addressLines, index, { ...this.editedAddressLine });
        }
        this.editAddressDialog = false;
        this.$refs.snackbar.show("Address line updated", "green");
        return;
      }

      const url = `/customer-address-lines/${this.editedAddressLine.id}`;
      const payload = {
        addressLine: this.editedAddressLine.addressLine
      };
      const self = this;
      this.addressLoader = true;
      this.$store
        .dispatch("put", { url, data: payload })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.addressLoader = false;
            self.editAddressDialog = false;
            self.getAddressLines();
            self.$refs.snackbar.show("Address line updated successfully", "green");
          } else {
            self.addressLoader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.addressLoader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    openDeleteAddressModal(item) {
      this.selectedAddressLine = item;
      this.deleteAddressDialog = true;
    },
    deleteAddressLine() {
      if (!this.selectedAddressLine.id) {
        // If it's a local item without ID, remove from local array
        const index = this.addressLines.indexOf(this.selectedAddressLine);
        if (index !== -1) {
          this.addressLines.splice(index, 1);
        }
        this.deleteAddressDialog = false;
        this.$refs.snackbar.show("Address line deleted", "green");
        return;
      }

      const url = `/customer-address-lines/${this.selectedAddressLine.id}`;
      const self = this;
      this.addressLoader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.addressLoader = false;
            self.deleteAddressDialog = false;
            self.getAddressLines();
            self.$refs.snackbar.show("Address line deleted successfully", "green");
          } else {
            self.addressLoader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.addressLoader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      var userId = localStorage.getItem("userId");
      const self = this;
      this.$store
        .dispatch("get", `/user-stores/${userId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getPriceLists(), this.getPaymentTerms(), this.getOwners(), this.getStores()]);
  }
};
</script>